export const LogoMark = ({ size = 44, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" className={className} data-testid="logo-mark">
    <defs>
      <linearGradient id={`gold-${size}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset="0.5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#B38728" />
      </linearGradient>
    </defs>
    <rect width="80" height="80" rx="18" fill="#0B132B" />
    <rect x="2" y="2" width="76" height="76" rx="16" fill="none" stroke="#D4AF37" strokeOpacity="0.6" strokeWidth="1.5" />
    <g fill="none" stroke={`url(#gold-${size})`} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M24 18 v44" />
      <path d="M24 18 h14 a10 10 0 0 1 0 20 h-14" />
      <path d="M24 38 h16 a11 11 0 0 1 0 24 h-16" />
      <path d="M46 18 v44" />
      <path d="M46 18 h11 a10 10 0 0 1 0 20 h-11" />
      <path d="M55 38 l10 24" />
    </g>
  </svg>
);

export const LogoFull = () => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark size={42} />
    <div className="leading-tight">
      <div className="font-display font-extrabold text-lg text-[#F8FAFC]">براح الرقمية</div>
      <div className="font-mono-tech text-[10px] tracking-[0.25em] text-[#D4AF37]/80" dir="ltr">BRAH-TECH.COM</div>
    </div>
  </div>
);
